import { render } from "./AdminCourseShedule.vue?vue&type=template&id=7ad8bd9a"
import script from "./AdminCourseShedule.vue?vue&type=script&lang=js"
export * from "./AdminCourseShedule.vue?vue&type=script&lang=js"

import "./AdminCourseShedule.vue?vue&type=style&index=0&id=7ad8bd9a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__